import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('div', {
    staticClass: "ovh mb-15"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('已选')) + " " + _vm._s(_vm.t('common', '：')) + _vm._s(_vm.selectedList.length))]), _c('a-dropdown', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'shipping_address_export',
      expression: "'shipping_address_export'"
    }]
  }, [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "shipping_address_book_export_all",
      "id": "shipping_address_book_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "shipping_address_book_export_selected",
      "id": "shipping_address_book_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5BFC\u51FA")
    }
  }, [_vm._v(_vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1), _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'shipping_address_delete_bulk',
      expression: "'shipping_address_delete_bulk'"
    }],
    staticClass: "ml-10",
    attrs: {
      "data-permission": "shipping_address_book_batch_delete",
      "id": "shipping_address_book_batch_delete",
      "fbu-analyse-name": $t("\u5220\u9664")
    },
    on: {
      "click": function ($event) {
        return _vm.handleDelete(undefined);
      }
    }
  }, [_vm._v(_vm._s(_vm.tc('删除')))])], 1), _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'shipping_address_add',
      expression: "'shipping_address_add'"
    }],
    staticClass: "fr",
    attrs: {
      "data-permission": "shipping_address_book_add",
      "id": "shipping_address_book_add",
      "type": "primary",
      "fbu-analyse-name": $t("\u65B0\u589E")
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.tc('新增')))])], 1), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "useMouseTool": "",
      "columns": _vm.columns,
      "data-source": _vm.dataList,
      "row-selection": _vm.rowSelection,
      "row-key": "id",
      "name": "shippingAddressBookList",
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "detailedaddress",
      fn: function (ref) {
        var record = ref.record;
        return [_c('text-ellipses', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.detailedaddress,
            expression: "record.detailedaddress"
          }],
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('span', [_vm._v(_vm._s(record.detailedaddress))])])];
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [_c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'shipping_address_edit',
            expression: "'shipping_address_edit'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-permission": "shipping_address_book_edit",
            "id": "shipping_address_book_edit",
            "fbu-analyse-name": $t("\u7F16\u8F91")
          },
          on: {
            "click": function ($event) {
              return _vm.handleEdit(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('编辑')))]), _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'shipping_address_delete',
            expression: "'shipping_address_delete'"
          }],
          attrs: {
            "data-permission": "shipping_address_book_delete",
            "id": "shipping_address_book_delete",
            "fbu-analyse-name": $t("\u5220\u9664")
          },
          on: {
            "click": function ($event) {
              return _vm.handleDelete(record['id']);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('删除')))])]);
      }
    }])
  })], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "isFixed": "",
      "name": "shippingAddressBookList",
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  }), _c('add-shipping-address-modal', {
    ref: "addShippingAddressModal",
    on: {
      "success": function ($event) {
        return _vm.queryShippingAddress();
      }
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };